import Vue from 'vue'
import App from './App.vue'
import global from "@/utlis/global.vue";

import ShareitReport from '@shareit/report'
import VueClipboard from 'vue-clipboard2'


const reportInstance = new ShareitReport({
	appId: 'VML-invite-share',
	project: 'fe-analysis-data', //上报到metis项目名 创建项目时的名称 不能"_"
	logStore: 'report', //metis创建日志里的日志名称 不能"_"
	env: process.env.VUE_APP_REPORT_SDK_ENV, //环境
  groupName: process.env.VUE_APP_REPORT_SDK_GROUPNAME,
})
 

Vue.prototype.$reportInstance = reportInstance;

Vue.config.productionTip = false
Vue.prototype.$global = global


// toast
Vue.component("toast", (resolve) => {
	import("@/components/toast.vue").then((toast) => {
		resolve(toast.default)
	})
})
//cpy
Vue.use(VueClipboard)


new Vue({
  render: h => h(App),
}).$mount('#home')
